import React from 'react';
import PropTypes from 'prop-types';
import {
    Divider,
    Grid,
    Typography,
} from '@mui/material';
import { CommonModal, PrimaryButton } from '../index';
import { Grey3, red } from '../../../color_utils';
import { trakrefFontFamily } from '../../../utils';
import WrongLocationIcon from '@mui/icons-material/WrongLocation';

const LocationPermissionModal = ({
    open,
    close,
}) => (
    <CommonModal
        open={open}
        close={close}
        renderCloseIcon={false}
        width={444}
    >
        <Grid container sx={{p:{ xs: 2, md: 0}}}>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <WrongLocationIcon sx={{ color: red, fontSize: 28, mr: 1 }} />
                <Typography
                    sx={{
                        fontFamily: trakrefFontFamily,
                        fontWeight: 700,
                        fontSize: '1.25rem',
                        color: 'rgba(26, 23, 59, 0.87)',
                    }}
                >
                    Location access is blocked
                </Typography>
            </Grid>
            <Grid item xs={12} sx={{ mb: 3 }}>
                <Typography
                    sx={{
                        fontFamily: trakrefFontFamily,
                        fontWeight: 400,
                        fontSize: '1rem',
                        color: Grey3,
                    }}
                >
                    It looks like location access was turned off before, and your browser remembered that choice.
                </Typography>
                <Typography
                    sx={{
                        fontFamily: trakrefFontFamily,
                        fontWeight: 400,
                        fontSize: '1rem',
                        color: Grey3,
                        mt: 2,
                    }}
                >
                    To fix that, open Trakref in your browser's settings and <span style={{ fontWeight: 600 }}>allow location access</span>, then refresh this page.
                </Typography>
            </Grid>
            <Grid item xs={12} sx={{ mb: 2 }}>
                <Divider sx={{ width: '100%' }} />
            </Grid>
            <Grid item xs={12}>
                <PrimaryButton
                    fullWidth
                    useLargeButton
                    buttonText='GOT IT'
                    onClick={close}
                    width={100}
                />
            </Grid>
        </Grid>
    </CommonModal>
);

LocationPermissionModal.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
};

export default LocationPermissionModal;
